import { nextTick, onBeforeUnmount, watch } from 'vue'

const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])'
].join(', ')

// 手写弹窗/抽屉的可达性基线:打开时聚焦面板、Tab 焦点圈禁、Esc 关闭、关闭后归还焦点。
export function useModalA11y(isOpen, panelRef, onClose) {
  let previousFocus = null

  function trapTab(event) {
    const panel = panelRef.value
    if (!panel) return
    const focusable = Array.from(panel.querySelectorAll(FOCUSABLE_SELECTOR))
      .filter(el => el.offsetParent !== null || el === document.activeElement)
    if (focusable.length === 0) {
      event.preventDefault()
      panel.focus()
      return
    }
    const first = focusable[0]
    const last = focusable[focusable.length - 1]
    if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
      event.preventDefault()
      first.focus()
    }
  }

  function onKeydown(event) {
    if (event.key === 'Escape') {
      event.stopPropagation()
      onClose?.()
      return
    }
    if (event.key === 'Tab') {
      trapTab(event)
    }
  }

  watch(isOpen, async open => {
    if (open) {
      previousFocus = document.activeElement
      await nextTick()
      const panel = panelRef.value
      if (!panel) return
      const target = panel.querySelector(FOCUSABLE_SELECTOR) || panel
      target.focus()
      document.addEventListener('keydown', onKeydown, true)
    } else {
      document.removeEventListener('keydown', onKeydown, true)
      if (previousFocus && document.contains(previousFocus)) {
        previousFocus.focus()
      }
      previousFocus = null
    }
  })

  onBeforeUnmount(() => {
    document.removeEventListener('keydown', onKeydown, true)
  })
}
